<div class="section">
  <div class="header">E-Mail-Adresse ändern - Schritt 2 / 2</div>
  <div class="body">
    <div class="actions">
      <button id="submit" mat-stroked-button color="primary" (click)="send()">
        Änderung der E-Mail-Adresse bestätigen
      </button>
    </div>
    <div class="description">
      Nach dem erfolgreichen aktualisieren Deiner E-Mail-Adresse loggen wir
      Dich automatisch aus.
    </div>
    <a routerLink="/login">zum Login</a>
  </div>
</div>
